import { useSelector } from 'react-redux';

import { API_DOMAIN, API_PORT, CONTEXT_PATH, OFFLINE_API_PORT } from '../env/variables';

// TODO: have to start using this in other places.
export default function useResourceUrl(value: string, filename: string) {
  const token = useSelector((state: any) => state.authenticate.token);
  const isOffline = useSelector((state: any) => state.resources.offlineMode);
  return `${window.location.protocol}//${API_DOMAIN}:${isOffline ? OFFLINE_API_PORT : API_PORT}${CONTEXT_PATH}/api/download?token=${token}&view=false&value=${value}&filename=${filename}`;
}
